export default __webpack_public_path__ + "static/media/orange.c79693ac.svg";